export const zIndex = {
  header: 280,
  bottomNav: 300,
  dropdown: 360,
  scrim: 350,
  modal: 400,
  modalConfirm: 480,
  modalHigh: 500,
  modalTop: 520,
  toast: 540,
};
